import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../../Common/Tooltip';

// Styles
import './style.scss';

const TableAssignmentCell = ({ tasks }) => {
  const [currentTasks, setCurrentTasks] = useState([]);


  useEffect(() => {
    setCurrentTasks(tasks);
  }, [tasks]);


  const getInitials = useCallback((user) => {
    if (!user) {
      return '';
    }
    const initials = [];
    if (user.first_name) {
      initials.push(user.first_name.substring(0, 1));
    }
    if (user.last_name) {
      initials.push(user.last_name.substring(0, 1));
    }
    return initials.join('');
  }, []);

  const getName = useCallback((user) => {
    if (!user) {
      return '';
    }
    return (
      <>
        <span>
          {user.first_name} {user.last_name}
        </span>
        <span>{user.email}</span>
      </>
    );
  }, []);

  return (
    <div>
    {currentTasks.map(task => (
      <div className="TableAssignmentCell" key={task.id}>
        {task.account_users_assigned.map((user) => {
          return (
            <Tooltip message={getName(user.user)} className="Tooltip_Blue" key={user.id}>
              <div className={`assigned-user assigned-user--${user.type ? user.type : 'user'}`}>
                {getInitials(user.user)}
              </div>
            </Tooltip>
          );
        })}
      </div>
    ))}
  </div>
  );
}

TableAssignmentCell.propTypes = {
  tasks: PropTypes.array.isRequired,
}

export default TableAssignmentCell;